import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";

export default function LoadingState() {
  return (
    <Box
      sx={{
        width: "100%",
        minHeight: { xs: 260, md: 360 },
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 2,
      }}
    >
      <CircularProgress
        size={42}
        thickness={2.5}
      />

      <Typography
        sx={{
          fontSize: "0.75rem",
          letterSpacing: "0.14em",
          textTransform: "uppercase",
          color: "rgba(0, 0, 0, 0.5)",
        }}
      >
        Loading...
      </Typography>
    </Box>
  );
}